export default __webpack_public_path__ + "c37295b2112fb04ec15c00a3dced6a5f.png";